export default {
    meta: {
        title: '拓店宝-拓店提报搜索',
        url: '/aproval/manage',
        urlName: '拓店调研',
    }
};
